import { toast } from "react-toastify";

interface ILastErrorLog {
  message: string;
  time: number;
}

const LAST_ERROR_KEY = "lastError";

export const useToasts = () => {
  // progressClassName: "toast--success",
  // icon: <Check style={{ height: "100%" }} />,

  const saveLastError = (message: string) => {
    const item: ILastErrorLog = {
      message,
      time: Date.now(),
    };
    localStorage.setItem(LAST_ERROR_KEY, JSON.stringify(item));
  };

  const isItWasLastError = (message: string): boolean => {
    const raw = localStorage.getItem(LAST_ERROR_KEY);
    if (raw === null) return false;
    //dev.logt("TOAST_ERROR", "Data", raw);
    try {
      const item = JSON.parse(raw) as ILastErrorLog;
      if (item) {
        if (message.localeCompare(item.message) === 0) {
          if (Date.now() - item.time < 1000) {
            return true;
          }
        }
      }
    } catch {}
    return false;
  };

  const error = (msg: string) => {
    //if (msg === MSG_SESSION_OVER) {
    if (isItWasLastError(msg)) {
      return;
    }
    /*
    const prev = prevLogoutMsg.current; 
    const now = Date.now();
    prevLogoutMsg.current = now;
    if (now - prev < 500) {
      dev.log("Hide error");
      return;
    }*/
    //}
    saveLastError(msg);
    return toast.error(msg);
  };
  const success = (msg: string) => {
    return toast.success(msg, {
      progressClassName: "success__progress",
      autoClose: 500,
    });
  };

  const info = (msg: string) => {
    return toast.info(msg);
  };

  const loading = (boolean: boolean) => {
    if (boolean) {
      return toast.loading("...");
    } else {
      return toast.dismiss();
    }
  };

  const dismis = () => toast.dismiss();

  return {
    error,
    success,
    dismis,
    info,
    loading,
  };
};

export const toasts = useToasts(); // должно работать, поскольку в useToasts не используются никакие функции react